/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * フォントファミリー (null許容)
 * @export
 */
export const FontFamilyNullable = {
    Gothic: 'gothic',
    Mincho: 'mincho',
    Monospace: 'monospace'
};
export function FontFamilyNullableFromJSON(json) {
    return FontFamilyNullableFromJSONTyped(json, false);
}
export function FontFamilyNullableFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function FontFamilyNullableToJSON(value) {
    return value;
}
